import { AdditionalClientDataService } from '@vtblife/layout-components/shell/utils';

export class RootClientData implements AdditionalClientDataService {
    constructor(private readonly deviceIp: string) {}

    getData(): { [p: string]: any } {
        return { deviceIp: this.deviceIp };
    }
}
